export default __webpack_public_path__ + "static/media/MirathLogo.ae830159.svg";